export enum MessageBoxIcon {
    None = 0,
    Confirmation,
    Information,
    Warning,
    WarningTriangle
}

export enum MessageBoxButtons {
    Ok = 1,
    OkCancel = 2,
    YesNo = 3,
    AcceptReject = 4,
    RemoveCancel = 5,
    Close = 6
}

export enum MessageBoxResult {
    Ok = 1,
    Cancel,
    Yes,
    No,
    Accept,
    Reject
}

export class MessageBoxInjectData {
    constructor(data: {
        title: string;
        message: string;
        information: string;
        informationLine2: string;
        icon: MessageBoxIcon;
        buttons: MessageBoxButtons;
        textForYes?: string;
        textForNo?: string;
    }) {
        this.title = data.title;
        this.message = data.message;
        this.information = data.information;
        this.informationLine2 = data.informationLine2;
        this.icon = data.icon;
        this.buttons = data.buttons;
        this.textForYes = data.textForYes;
        this.textForNo = data.textForNo;
    }

    title: string;
    message: string;
    information: string;
    informationLine2: string;
    icon: MessageBoxIcon;
    buttons: MessageBoxButtons;
    textForYes?: string;
    textForNo?: string;
}
